//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectIBasePlaneList.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AddEndTemplate",1,0],[0,"AddStartTemplate",1,0],[0,"AngleTolerance",1,0],[0,"BasePlaneType",1,0],[0,"CoordinateSystem",1,"CoordinateSystem",0],[0,"CornerCutType",1,0],[0,"CreateSeparateParts",1,0],[0,"DistanceTolerance",1,0],[1,"EndMinimumDistance",0,"Expression",0],[1,"EndXTemplateOffset",0,"Expression",0],[1,"EndYTemplateOffset",0,"Expression",0],[0,"MarkingLinesDirectionType",1,0],[0,"MaterialGradeName",1,0],[0,"MaterialName",1,0],[0,"MeasurementSide",1,0],[1,"PlaneAutomatic",0,"SelectIBasePlaneList",0],[0,"PlaneMethod",1,0],[0,"SightLineCutType",1,0],[0,"SpecifyXPlane",1,"Plane",0],[0,"SpecifyYPlane",1,"Plane",0],[1,"StartMinimumDistance",0,"Expression",0],[1,"StartXTemplateOffset",0,"Expression",0],[1,"StartYTemplateOffset",0,"Expression",0],[1,"Surface",0,"ScCollector",0],[0,"TemplatePlaneType",1,0],[0,"TemplateSetName",1,0],[1,"Thickness",0,"Expression",0],[0,"Type",1,0],[0,"XNumber",1,0],[1,"XOffset",0,"Expression",0],[0,"XPlaneUserDefined",1,0],[0,"YNumber",1,0],[1,"YOffset",0,"Expression",0],[0,"YPlaneUserDefined",1,0]],[],[]];
SPLM.Features.ShipDesign.ShellTemplateBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ShellTemplateBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ShellTemplateBuilder.Types = Object.freeze({
    "Manual" : "Manual", "InferCoordinateSystem" : "InferCoordinateSystem"});

SPLM.Features.ShipDesign.ShellTemplateBuilder.PlaneLocationTypes = Object.freeze({
    "Existing" : "Existing", "Offset" : "Offset", "Number" : "Number"});

SPLM.Features.ShipDesign.ShellTemplateBuilder.MarkingTypes = Object.freeze({
    "None" : "None", "XDirectionOnly" : "XDirectionOnly", "YDirectionOnly" : "YDirectionOnly", "XandYDirections" : "XandYDirections"});

SPLM.Features.ShipDesign.ShellTemplateBuilder.CornerCutTypes = Object.freeze({
    "None" : "None", "Start" : "Start", "End" : "End"});

SPLM.Features.ShipDesign.ShellTemplateBuilder.SightLineCutTypes = Object.freeze({
    "None" : "None", "TowardStart" : "TowardStart", "TowardEnd" : "TowardEnd"});

SPLM.Features.ShipDesign.ShellTemplateBuilder.BasePlaneTypes = Object.freeze({
    "FromPlanes" : "FromPlanes", "FromPlate" : "FromPlate"});

SPLM.Features.ShipDesign.ShellTemplateBuilder.TemplatePlaneTypes = Object.freeze({
    "Inferred" : "Inferred", "NormalToBasePlane" : "NormalToBasePlane"});

SPLM.Features.ShipDesign.ShellTemplateBuilder.MeasurementSideTypes = Object.freeze({
    "Start" : "Start", "End" : "End"});

export default SPLM;